var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AttachmentList',{attrs:{"card-id":_vm.card.id,"removable":true},on:{"deleteAttachment":_vm.deleteAttachment,"restoreAttachment":_vm.restoreAttachment}})}
var staticRenderFns = []

export { render, staticRenderFns }